import { NgModule } from '@angular/core';

import { FormsModule} from '@angular/forms'; // Import FormsModule
import { BrowserModule } from '@angular/platform-browser';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { VideoBackgroundComponent } from './video-background/video-background.component';
import { HeaderComponent } from './header/header.component';
import { HttpClientModule } from '@angular/common/http';


import { HomeComponent } from './home/home.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { FooterComponent } from './footer/footer.component';
import { PencarianComponent } from './pencarian/pencarian.component';
import { ReviewComponent } from './review/review.component';
import { ReviewBComponent } from './review-b/review-b.component';
import { SmartchComponent } from './smartch/smartch.component';
import { PertanyaanComponent } from './pertanyaan/pertanyaan.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PopularComponent } from './popular/popular.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SlickCarouselModule } from 'ngx-slick-carousel';



import { DeluxeBoatComponent } from './deluxe-boat/deluxe-boat.component';
import { VipBoatComponent } from './vip-boat/vip-boat.component';
import { VvipBoatComponent } from './vvip-boat/vvip-boat.component';
import { LoginPelangganComponent } from './login-pelanggan/login-pelanggan.component';


import { SocialLoginModule, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { FacebookLoginProvider } from '@abacritt/angularx-social-login';
import { NgxCaptchaModule } from 'ngx-captcha';
import { LoginSocialComponent } from './login-social/login-social.component';
import { LoginWaComponent } from './login-wa/login-wa.component';
import { LoginDaftarComponent } from './login-daftar/login-daftar.component';
import { DetailBoatComponent } from './detail-boat/detail-boat.component';
import { BookingComponent } from './booking/booking.component';
import { ItineraryBoatComponent } from './itinerary-boat/itinerary-boat.component';
import { SevicesBoatComponent } from './sevices-boat/sevices-boat.component';
import { BookingPelangganComponent } from './booking-pelanggan/booking-pelanggan.component';
import { DetailBookingComponent } from './detail-booking/detail-booking.component';
import { AlorIslandComponent } from './alor-island/alor-island.component';
import { BandaIslandComponent } from './banda-island/banda-island.component';
import { KomodoNationalParkComponent } from './komodo-national-park/komodo-national-park.component';
import { OpenTripKomodoComponent } from './open-trip-komodo/open-trip-komodo.component';
import { OpenTripOutsideKomodoComponent } from './open-trip-outside-komodo/open-trip-outside-komodo.component';
import { RajaAmpatComponent } from './raja-ampat/raja-ampat.component';
import { AccomodationComponent } from './accomodation/accomodation.component';
import { AccountComponent } from './account/account.component';
import { AccountPhoneNumberComponent } from './account-phone-number/account-phone-number.component';
import { DetailBoatopenComponent } from './detail-boatopen/detail-boatopen.component';
import { FeatopComponent } from './featop/featop.component';
import { FeatbcComponent } from './featbc/featbc.component';
import { HasilCariComponent } from './hasil-cari/hasil-cari.component';
import { DetailBoatoutsideComponent } from './detail-boatoutside/detail-boatoutside.component';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiInterceptorInterceptor } from './interceptors/api.interceptor.interceptor';
import { ActivityTagsModule } from './shared/activity-tags/activity-tags.module';

import { BlogHomeComponent } from './blog-home/blog-home.component';
import { BlogComponent } from './blog/blog.component';
import { BlogDetailComponent } from './blog-detail/blog-detail.component';

@NgModule({
  declarations: [
    AppComponent,
    VideoBackgroundComponent,
    HeaderComponent,
    HomeComponent,
    AboutUsComponent,
    FooterComponent,
    PencarianComponent,
    ReviewComponent,
    ReviewBComponent,
    SmartchComponent,
    PertanyaanComponent,
    PopularComponent,
    DeluxeBoatComponent,
    VipBoatComponent,
    VvipBoatComponent,
    LoginPelangganComponent,
    LoginSocialComponent,
    LoginWaComponent,
    LoginDaftarComponent,
    DetailBoatComponent,
    BookingComponent,
    ItineraryBoatComponent,
    SevicesBoatComponent,
    BookingPelangganComponent,
    DetailBookingComponent,
    AlorIslandComponent,
    BandaIslandComponent,
    KomodoNationalParkComponent,
    OpenTripKomodoComponent,
    OpenTripOutsideKomodoComponent,
    RajaAmpatComponent,
    AccomodationComponent,
    AccountComponent,
    AccountPhoneNumberComponent,
    DetailBoatopenComponent,
    FeatopComponent,
    FeatbcComponent,
    HasilCariComponent,
    DetailBoatoutsideComponent,
    BlogHomeComponent,
    BlogComponent,
    BlogDetailComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule, // Ensure FormsModule is imported here
    ReactiveFormsModule,
    ActivityTagsModule,
    NgxCaptchaModule,
    NgbModule,
    SocialLoginModule, // Tambahkan SocialLoginModule
    SlickCarouselModule, 
   
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptorInterceptor,
      multi: true
    },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('568126995932318') // Ganti dengan App ID
          },
        ]
      } as SocialAuthServiceConfig,
    },

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
